module.exports = __webpack_public_path__ + "img/secondary-logo.67dfa54c.png";